export const ADD_INFO_MESSAGE = "ADD_INFO_MESSAGE";
export const GET_INFO_MESSAGES = "GET_INFO_MESSAGES";
export const ADD_WARN_MESSAGE = "ADD_WARN_MESSAGE";
export const GET_WARN_MESSAGES = "GET_WARN_MESSAGES";
export const RESET_MESSAGES = "RESET_MESSAGES";
export const RESET_INFO_MESSAGES = "RESET_INFO_MESSAGES";
export const RESET_WARN_MESSAGES = "RESET_WARN_MESSAGES";
export const SET_ROW_WARNINGS = "SET_ROW_WARNINGS";

export const addInfoMessage = (infoMessage: string) => ({
  type: ADD_INFO_MESSAGE,
  infoMessage,
});

export const addWarnMessage = (warnMessage: string) => ({
  type: ADD_WARN_MESSAGE,
  warnMessage,
});

export const setRowWarnings = (rowWarnings: number[]) => ({
  type: SET_ROW_WARNINGS,
  rowWarnings,
});

const initialState = {
  infoMessages: [],
  warnMessages: [],
  rowWarnings: [],
};

export const messageReducer = (state = initialState, action: any) => {
  let { rowWarnings } = action;
  switch (action.type) {
    case RESET_MESSAGES:
      return initialState;
    case RESET_INFO_MESSAGES:
      const infoMessages: any = [];
      rowWarnings = [];
      return { ...state, infoMessages, rowWarnings };
    case RESET_WARN_MESSAGES:
      const warnMessages: any = [];
      return { ...state, warnMessages };
    case SET_ROW_WARNINGS:
      return { ...state, rowWarnings };
    case ADD_INFO_MESSAGE:
      const { infoMessage } = action;
      return { ...state, infoMessages: [...state.infoMessages, infoMessage] };
    case ADD_WARN_MESSAGE:
      const { warnMessage } = action;
      return { ...state, warnMessages: [...state.warnMessages, warnMessage] };
    default:
      return state;
  }
};
